import SpinnerModal from './spinner';
import AdvertenceDialog from './advertence';
import InfoDialog from './information';

export {SpinnerModal, AdvertenceDialog, InfoDialog};
